/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `HOUR` - hod
 *   * `PAGE` - strana
 *   * `DM2` - dm2
 * ```
 */
export const PriceListItemUnitsEnum = { HOUR: 'HOUR', PAGE: 'PAGE', DM2: 'DM2' } as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type PriceListItemUnitsEnum = ValuesOf<typeof PriceListItemUnitsEnum>;

export type PriceListItemUnitsEnumRequest = PriceListItemUnitsEnum;
export type PriceListItemUnitsEnumResponse = PriceListItemUnitsEnum;
